import { render } from "./payement.vue?vue&type=template&id=6db3206c&scoped=true"
import script from "./payement.vue?vue&type=script&lang=js"
export * from "./payement.vue?vue&type=script&lang=js"

import "./payement.vue?vue&type=style&index=0&id=6db3206c&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db3206c"]])

export default __exports__